import { jsx as _jsx } from "react/jsx-runtime";
export const Pre = ({ realClassName, realStyle, children }) => {
    return _jsx("pre", { className: realClassName, style: realStyle, children: children });
};
